<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
      </div>
      <div style="width: 500px;">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="ruleForm.activityName" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker v-model="ruleForm.activityTime" type="daterange" range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input v-model="ruleForm.activityExplain" type="textarea" :rows="4" placeholder="请输入活动说明" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" :rules="configRules" label-width="100px">
          <el-form-item label="消费维度" prop="consumptionDimension">
            <el-radio-group v-model="configForm.consumptionDimension">
                  <el-radio label="1">电量</el-radio>
              <el-radio label="2">金额</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖励标准" prop="amount">
            <div v-if="configForm.consumptionDimension==='1'" class="d-flex amount">
              <div>满</div>
              <el-input v-model="configForm.amount" type="number" placeholder="请输入电度数" />
              <div>度</div>
            </div>
            <div v-if="configForm.consumptionDimension==='2'" class="d-flex amount">
              <div>满</div>
              <el-input v-model="configForm.amount" type="number" placeholder="请输入金额" />
              <div>元</div>
            </div>
          </el-form-item>
          <template v-for="(row,index) in configForm.coupon">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" prop="coupon">
              <div class="d-flex">
                <el-select v-model="row.couponId" filterable style="width: 200px;" placeholder="请选择优惠券" @change="(val)=>couponChange(val,index)">
                  <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                </el-select>
                <el-input v-model="row.count" class="ml-20" style="width: 100px;" placeholder="请输入数量" />
                <div class="ml-20">张</div>
                <i class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addCoupon(index)" />
                <i v-show="index!==0" class="icon-jia ml-20 el-icon-remove-outline" @click="delCoupon(index)" />
              </div>
              <div class="d-flex currentStock">当前库存：{{ row.totalNum }}</div>
            </el-form-item>
          </template>
          <el-form-item label="可参与次数" prop="partakeNum">
            <el-input v-model="configForm.partakeNum" placeholder="请输入当前活动用户可参与次数" />
          </el-form-item>
          <el-form-item label="活动电站" prop="powerStation">
            <el-radio-group v-model="configForm.powerStation">
              <el-radio v-for="(item, index) in activityPowerStation" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择运营商 -->
            <div v-show="configForm.powerStation===2" class="border">
              <el-input v-model="filterOperatorText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeOperator"
                :data="operatorTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
              />
            </div>
            <!-- 选择电站 -->
            <div v-show="configForm.powerStation===3" class="border">
              <el-input v-model="filterStationText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeStation"
                :data="stationTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="partakeForm" :model="partakeForm" :rules="partakeRules" label-width="100px">
          <el-form-item label="可参与用户" prop="partakeUser">
            <el-radio-group v-model="partakeForm.partakeUser">
              <el-radio v-for="(item, index) in partakeUserItem" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择企业 -->
            <div v-show="partakeForm.partakeUser===2" class="border">
              <el-input v-model="filterMechanismText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
				:check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.partakeUser===3" class="border">
              <el-input v-model="filterTagText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { numberfilter } from '@/utils/tool'
export default {
  data() {
    return {
      type: 3,
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      filterOperatorText: '', // 运营商过滤
      filterStationText: '', // 电站过滤
      filterMechanismText: '', // 企业过滤
      filterTagText: '', // 标签过滤
      ruleForm: {
        activityName: '', // 活动名称
        activityTime: [], // 活动时间
        activityExplain: ''// 活动说明
      },
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        activityExplain: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ]
      },
      // 所有的优惠券数据
      allCoupon: [],
      // 活动电站
      activityPowerStation: [
        {
          label: '全部电站',
          id: 1
        }, {
          label: '选择运营商',
          id: 2
        }, {
          label: '选择电站',
          id: 3
        }
      ],
      operatorTreeData: [], // 运营商树的全部数据
      stationTreeData: [], // 电站树的全部数据
      configForm: {
        consumptionDimension: '1', // 消费维度
        amount: '', // 奖励标准
        coupon: [// 优惠券
          {
            couponId: '', // 优惠券id
            count: '', // 优惠券数量
            totalNum: ''// 优惠券库存
          }
        ],
        partakeNum: '', // 可参与次数
        powerStation: 1, // 活动电站单选框
        operator: [], // 选择运行商时的树数据
        station: []// 选择电站时的树数据
      },
      configRules: {
        consumptionDimension: [
          { required: true, message: '请选择消费维度', trigger: 'change' }
        ],
        amount: [
          { required: true, message: '请输入奖励标准', trigger: 'blur' }
        ],
        coupon: { required: true, trigger: 'change', validator: (rewardRules, value, cb) => {
          if (this.couponRule) {
            return cb(new Error(this.couponRule))
          }
          return cb()
        } },
        partakeNum: [
          { required: true, message: '请输入可参与次数', trigger: 'blur' }
        ],
        powerStation: [
          { required: true, message: '请选择活动电站', trigger: 'change' }
        ]
      },
      // 可参与用户字段的单选数据
      partakeUserItem: [
        {
          label: '全部用户',
          id: 1
        }, {
          label: '选择企业',
          id: 2
        }, {
          label: '选择标签',
          id: 3
        }
      ],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      partakeForm: {
        partakeUser: 1, // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: []// 选择标签
      },
      partakeRules: {
        partakeUser: [
          { required: true, message: '请选择可参与用户', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    // 优惠券的动态校验
    couponRule() {
      const dataArray = this.configForm.coupon
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.couponId === '' && !currentObj.couponId.length) {
          return '请选择优惠券'
        }
        if (!currentObj.count && !currentObj.count.length) {
          return '请输入数量'
        }
        if (currentObj.totalNum && Number(currentObj.count) > currentObj.totalNum) {
          return '优惠券数量大于库存数量'
        }
      }
      return ''
    }
  },
  watch: {
    filterOperatorText(val) {
      this.$refs.treeOperator.filter(val)
    },
    filterStationText(val) {
      this.$refs.treeStation.filter(val)
    },
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val)
    },
    filterTagText(val) {
      this.$refs.treeTag.filter(val)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.loadTree()
      // 加载优惠券数据
      this.loadCoupon()
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载全部运营商、电站、企业和标签数据
    loadTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: {
          treeDepth: 'ORG'
        },
        callback: resp => {
          this.operatorTreeData = resp
        }
      })
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: {
          treeDepth: 'STATION'
        },
        callback: resp => {
          this.stationTreeData = resp
        }
      })
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = resp
        }
      })
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType:'0' },
        callback: resp => {
          this.tagTreeData = resp
        }
      })
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
        status: 0,
        hasStock: true
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          this.allCoupon = resp.list
        }
      })
    },
    // 优惠券选择赋值
    couponChange(val, index) {
      this.allCoupon.forEach(item => {
        if (item.couponId === val) {
          this.configForm.coupon[index].totalNum = item.stock
        }
      })
    },
    /**
     * 表单添加一行优惠券
     */
    addCoupon(index) {
      const data = {
        couponId: '', // 优惠券id
        count: '', // 优惠券数量
        totalNum: ''// 优惠券库存
      }
      this.configForm.coupon.splice(index + 1, 0, data)
    },
    /**
     * 删除删除一行优惠券
     */
    delCoupon(index) {
      this.configForm.coupon.splice(index, 1)
    },
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })

      let configFormBool = false
      this.$refs['configForm'].validate(valid => {
        configFormBool = valid
      })

      let partakeFormBool = false
      this.$refs['partakeForm'].validate(valid => {
        partakeFormBool = valid
      })
      // 如果三个表单都验证通过
      if (ruleFormBool && configFormBool && partakeFormBool) {
        // 进入提交数据函数
        this.submitData()
      }
    },
    submitData() {
      // if-else的代替写法，策略模式，提高代码质量
      const stationOptions = {
        1: () => {
          return ''
        },
        2: () => {
          const newdata = this.$refs.treeOperator.getCheckedKeys()
          return newdata.join(',')
        },
        3: () => {
          const newdata = this.$refs.treeStation.getCheckedKeys()
          return newdata.join(',')
        }
      }
      const userOptions = {
        1: () => {
          return ''
        },
        2: () => {
          const newdata = this.$refs.treeMechanism.getCheckedKeys()
          return newdata.join(',')
        },
        3: () => {
          const newdata = this.$refs.treeTag.getCheckedKeys()
          return newdata.join(',')
        }
      }
      const data = {
        type: this.type,
        name: this.ruleForm.activityName, // 活动名称
        start: this.ruleForm.activityTime[0], // 活动开始时间
        end: this.ruleForm.activityTime[1], // 活动结束时间
        description: this.ruleForm.activityExplain, // 活动说明
        consumptionType: this.configForm.consumptionDimension, // 消费维度
        times: this.configForm.partakeNum, // 可参与次数
        stationType: this.configForm.powerStation, // 活动电站
        // 活动电站下面的树的数据
        stationValue: stationOptions[this.configForm.powerStation](), // 字符串，以逗号分割
        userType: this.partakeForm.partakeUser, // 可参与用户
        // 可参与用户下面的树的数据
        userValue: userOptions[this.partakeForm.partakeUser](), // 字符串，以逗号分割
        coupons: [
          {
            amount: this.configForm.amount,
            coupons: this.configForm.coupon
          }
        ]
      }
      this.$store.dispatch('form/handle', {
        url: '/activity/save',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 1500
          })
          this.$router.go(-1)
        }
      })
    },
    // 树的节点筛选
    filterNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex{
    display: flex;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .border{
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
  .amount{
    /deep/.el-input{
      width: 70%;
      padding: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/singleAdd.vue